import { Routes } from "@angular/router";
import { WorkflowCspOneTariffOrderCancelComponent } from "./workflow-csp-one-tariff-order-cancel.component";

export const WorkflowCspOneTariffOrderCancelRouting: Routes = [
    {
        path: 'csp/change-tariff/:aid/order-cancel', component: WorkflowCspOneTariffOrderCancelComponent
    },
]
